"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRouteLabelMap = void 0;
var _array = require("../type-checks/array");
var _string = require("../type-checks/string");
/**
 * Method to transform routeDataArray into path for parsing by Breadcrumbs
 *
 * @name getRouteLabelMap
 * @param {array} [routeData = []] Route Data item
 * @param {array} [recursiveParentPaths = [""]] Any parent path derived from parent recusion
 * @returns {object} Object with keys containing path and derived label as value
 */
const getRouteLabelMap = function () {
  let routeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let recursiveParentPaths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [""];
  let routeLabelMap = {};
  routeData.forEach(routeDataItem => {
    const {
      children,
      index,
      label,
      path
    } = routeDataItem;
    if ((0, _string.isStringOfLength)(path)) {
      if (path !== "*" && path !== "/") {
        let routePathList = [...recursiveParentPaths, path];
        (0, _string.isStringOfLength)(label) && (routeLabelMap[routePathList.join("/")] = label);
        (0, _array.isArrayOfLength)(children) && (routeLabelMap = {
          ...routeLabelMap,
          ...getRouteLabelMap(children, routePathList)
        });
      }
    } else if (index && (0, _string.isStringOfLength)(label)) {
      routeLabelMap[recursiveParentPaths.join("/")] = label;
    }
  });
  return routeLabelMap;
};
exports.getRouteLabelMap = getRouteLabelMap;